import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProfileModel } from '../models/profile.model';
import { ApiResponse } from '../models/api-resoponse';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly apiUrl: string = environment.baseApi;

  isProfileIncomplete: boolean | null = null;

  constructor(private http: HttpClient) {}

  getMyProfile(): Observable<ApiResponse<ProfileModel>> {
    return this.http
      .get<
        ApiResponse<ProfileModel>
      >(this.apiUrl + 'charity-user/user/profile/')
      .pipe(
        map((response) => ({
          ...response,
          data: Object.assign(new ProfileModel(), response.data),
        })),
      );
  }

  updateMyProfile(newProfile: any): Observable<ApiResponse<ProfileModel>> {
    const snakeCased = {
      first_name: newProfile.firstName,
      last_name: newProfile.lastName,
      mobile_number: newProfile.mobileNumber,
      email: newProfile.email,
      linkedin: newProfile.linkedin,
      gender: newProfile.gender,
      avatar_id: newProfile.avatar_id,
      education_degree: newProfile.lastEducationDegree,
      field_of_study: newProfile.educationField,
      charities: newProfile.charityPositions.map((e: any) => ({
        charity_id: e.charityId,
        cooperation_type: e.cooperationType,
        position_ids: e.positionIds,
      })),
    };

    return this.http.post<ApiResponse<ProfileModel>>(
      this.apiUrl + 'charity-user/user/profile/',
      snakeCased,
    );
  }
}
